import React, { useEffect, useRef, useState } from "react";
import { DoctorDetails, Image } from "../../components/componentIndex";
import DoctorProfile from '../../assets/images/dashboard/profile-1.svg';
import DoctorProfileOne from '../../assets/images/doctor-photo/profile-1.svg';

import VisitsBgImg from '../../assets/images/visits/visits-bg.jfif';
import callToSchedule from '../../assets/images/call-to-schedule.svg';
import MapMarker from '../../assets/images/visits/white-map-marker.svg';
import { useNavigate } from "react-router-dom";
import { useAuthenticationContext } from "services/slices/AuthenticationSlicer";
import VisitService from 'services/API/visitService';
import { toast } from "react-toastify";
import visitList from '../../services/staticDataService';
import CloseIcon from '../../assets/images/doctorProfile/close-icon.svg';
import { Button } from "common/commonIndex";


const Visits = () => {
    const navigate = useNavigate();
    const [visitsInfo, setVisitsInfo] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedVisit, setSelectedVisit] = useState({});
    const [statusMessage, setStatusMessage] = useState({
        mainTitle: null,
        title: null,
        message: null,
        buttonName: null
    });
    const { state: data } = useAuthenticationContext();
    const [isFullScreen, setIsFullScreen] = useState(false);
    const popupRef = useRef(null);

    const goToAppointmentDetail = (visits) => {
        // if (!visits?.status) return;
        // if (visits.status !== "Scheduled") return; 
        setSelectedVisit(visits);
        // switch (visits?.status) {
        //     case 'Expired':
        //         setStatusMessage(prevState => ({
        //             ...prevState,  // Keep the previous state values
        //             message: 'We noticed that your colonoscopy appointment request was not finalized within the allocated time. We understand that things can get busy, but your health is important to us. To request another appointment, please go to the Discover tab'  // Set the new value for 'title'
        //         }));
        //         setIsFullScreen(true);

        //         // Handle the 'Expired' status here
        //         break;
        //     case 'Requested':
        //         setStatusMessage(prevState => ({
        //             ...prevState,  // Keep the previous state values
        //             title: 'Alert'  // Set the new value for 'title'
        //         }));
        //         setStatusMessage(prevState => ({
        //             ...prevState,  // Keep the previous state values
        //             message: 'Your requested colonoscopy is under review. We will notify you when once review is completed. Thank you for your patience'  // Set the new value for 'title'
        //         }));
        //         setIsFullScreen(true);
        //         // Handle the 'Requested' status here
        //         break;
        //     case 'Denied':
        //         setStatusMessage(prevState => ({
        //             ...prevState,  // Keep the previous state values
        //             mainTitle: 'Call to schedule'  // Set the new value for 'title'
        //         }));
        //         setStatusMessage(prevState => ({
        //             ...prevState,  // Keep the previous state values
        //             title: 'Schedule an appointment'  // Set the new value for 'title'
        //         }));

        //         setStatusMessage(prevState => ({
        //             ...prevState,  // Keep the previous state values
        //             message: 'Based on your answers, you will need an office visit before scheduling your colonoscopy.'
        //         }));

        //         setStatusMessage(prevState => ({
        //             ...prevState,  // Keep the previous state values
        //             buttonName: 'Call us'
        //         }));
        //         setIsFullScreen(true);
        //         // Handle the 'Scheduled' status here
        //         break;
        //     case 'Need Attention':
        //     case 'Completed':
        //         setStatusMessage(prevState => ({
        //             ...prevState,  // Keep the previous state values
        //             title: 'Pre-screening Questionnaire'  // Set the new value for 'title'
        //         }));

        //         setStatusMessage(prevState => ({
        //             ...prevState,  // Keep the previous state values
        //             message: 'Before we can confirm your appointment, we need to determine your eligibility. Please complete the following questionnaire. We will hold your appointment for 24 hours.'
        //         }));

        //         setStatusMessage(prevState => ({
        //             ...prevState,  // Keep the previous state values
        //             buttonName: 'Start the questionnaire'
        //         }));
        //         setIsFullScreen(true);
        //         // Handle the 'Scheduled' status here
        //         break;
        //     default:
        //         navigate('/appointment-detail?visitId=' + visits?.fkVisitId);
        //         // Handle the case when none of the above match
        //         break;
        // }
        if (!visits?.status) return;

        // Ignore cases where status is not relevant


        if (visits.status === "Expired") {
            setStatusMessage({
                message:
                    "We noticed that your colonoscopy appointment request was not finalized within the allocated time. We understand that things can get busy, but your health is important to us. To request another appointment, please go to the Discover tab",
            });
            setIsFullScreen(true);
        } else if (visits.status === "Requested") {
            setStatusMessage({
                title: "Alert",
                message:
                    "Your requested colonoscopy is under review. We will notify you when once review is completed. Thank you for your patience",
            });
            setIsFullScreen(true);
        } else if (visits.status === "Denied") {
            setStatusMessage({
                mainTitle: "Call to schedule",
                title: "Schedule an appointment",
                message:
                    "Based on your answers, you will need an office visit before scheduling your colonoscopy.",
                buttonName: "Call us",
            });
            setIsFullScreen(true);
        } else if (visits.status === "Need Attention" || visits.status === "Completed") {
            setStatusMessage({
                title: "Pre-screening Questionnaire",
                message:
                    "Before we can confirm your appointment, we need to determine your eligibility. Please complete the following questionnaire. We will hold your appointment for 24 hours.",
                buttonName: "Start the questionnaire",
            });
            setIsFullScreen(true);
        } else if (visits.status !== "Scheduled") {
            if (visits.status !== "Scheduled") return;
        } else {
            navigate("/appointment-detail?visitId=" + visits?.fkVisitId);
        }
    }



    useEffect(() => {
        getVisits();
    }, [])

    const getVisits = async () => {
        try {
            const accessToken = data?.userData?.result?.token;
            setIsLoading(true);
            const response = await VisitService.getVisits(accessToken);
            if (response?.statusCode === 200) {
                // Filter unique based on `fkProviderId`
                const uniqueAppointments = Array.from(
                    new Map(response.result.map(item => [item.fkProviderId, item])).values()
                );
                let list = uniqueAppointments;
                let createList = handleVisitList(list);
                setVisitsInfo(createList);
            }
            setIsLoading(false);
            return response;
        } catch (error) {
            setIsLoading(false);
            console.error("Login failed: ", error);
        }
    }
    const handleVisitList = (list) => {
        const transformedDoctors = list?.map((item) => {
            // Define doctorProfileUrl outside the returned object
            // const doctorProfileUrl = doctor?.profileSignedUrl
            //     ? !doctor?.profileSignedUrl?.includes('http') ? `http://52.90.68.54:3000${doctor.profileSignedUrl}` : doctor.profileSignedUrl
            //     : null;
            return {
                doctorInfo: {
                    name: item.firstName + ' ' + item.lastName + ', ' + item.credential,
                    specialization: item.specialtyName,
                    photo: item.doctorProfileSignedUrl,
                    firstName: item.firstName,
                    lastName: item.lastName
                },

                fkVisitId: item.fkVisitId,
                fkProviderId: item.fkProviderId,
                appointmentType: item.appointmentType,
                coverImageSignedUrl: item.coverImageSignedUrl,
                appointmentDate: item.appointmentDate,
                timeSlot: item.timeSlot,
                firstName: item.firstName,
                status: item.status,
                lastName: item.lastName,
                specialtyName: item.specialtyName,
                providerPhoneNumber: item.providerPhoneNumber,
                doctorProfileSignedUrl: item.doctorProfileSignedUrl,
                credential: item.credential,
                isQuestionnaireCompleted: item.isQuestionnaireCompleted,
                isDenied: item.isDenied,
                surgeryCenterNumber: item.surgeryCenterNumber,
                requestedDateFromMobile: item.requestedDateFromMobile,
                providerOfficeNumber: item.providerOfficeNumber,
                createdDate: item.createdDate,
                modifiedby: item.modifiedby,
                submissionDate: item.submissionDate
            };

        });
        return transformedDoctors;
    }

    const openFullScreen = () => {
        setIsFullScreen(true);
    };

    const closeFullScreen = () => {
        if (statusMessage?.title === 'Pre-screening Questionnaire') {
            const url = `/questionnaire?fkUserId=${selectedVisit?.fkProviderId}&appointmentId=${selectedVisit?.fkVisitId}&step=0`;
            navigate(url);
        }
        setIsFullScreen(false);
    };
    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setIsFullScreen(false);
            }
        };

        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [closeFullScreen]);
    return (
        <div className="custom-container">
            <div className="visits">
                <h3 className="visit-title">Visits</h3>

                {visitsInfo?.length > 0 ? (
                    <>
                        {visitsInfo.map((item, index) => (
                            <div className="visits-card card" onClick={() => goToAppointmentDetail(item)} key={index}>
                                <div className="top-doctors-profile visit-bg cursor-pointer"
                                    style={{ backgroundImage: `url(${index === 2 ? VisitsBgImg : item?.coverImageSignedUrl ? item?.coverImageSignedUrl : VisitsBgImg})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
                                    <div className="status visit-status">
                                        <span className={`badge ${item?.status?.toLowerCase() === 'requested' ? 'badge-warning' : item?.status?.toLowerCase() === 'completed' ? 'badge-primary' : item?.status?.toLowerCase() === 'scheduled' ? 'badge-scheduled' : item?.status?.toLowerCase() === 'denied' || item?.status?.toLowerCase() === 'need attention' ? 'badge-danger' : 'badge-white'}`}>
                                            {item.status}</span>
                                    </div>
                                    <div className="map-marker-icon">
                                        <Image imgUrl={MapMarker} altText={'marker'} className={'marker'} />
                                    </div>
                                </div>
                                {console.log('Cover Image URL:', item?.coverImageSignedUrl)}
                                {console.log('Fallback Image URL:', VisitsBgImg)}
                                <h5 className="title">{item?.appointmentType}</h5>
                                <p className="visit-datetime">{item?.appointmentDate} {item?.timeSlot}</p>
                                <DoctorDetails doctorInformation={item.doctorInfo} />
                            </div>
                        ))
                        }
                    </>
                ) : (
                    <>
                        {isLoading ? (
                            <>
                                {Array.from({ length: 3 }).map((_, index) => (
                                    <div className="visits-card card skeleton" key={index}>
                                        <div className="top-doctors-profile skeleton-bg" />
                                        <div className="skeleton-title" ></div>
                                        <div className="skeleton-text" ></div>
                                        <div className="doctor-detail">
                                            <div className="doctor-photo skeleton-bg" > </div>
                                            <div className="doctor-information ">
                                                <div className="name skeleton-text"></div>
                                                <div className="specialization skeleton-text"></div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </>
                            // <div className="loader-content">
                            //     <div className="loader"></div>
                            // </div>
                        ) : (
                            <div className="content"> {/* Replace this with your actual content */}
                                No visits scheduled yet
                            </div>
                        )}
                    </>
                )}

            </div>
            {isFullScreen && (
                <div className="fullscreen-overlay">
                    <div className={`fullscreen-overlay-content alert-fullscreen-overlay ${selectedVisit.status === 'Requested' ? 'alert-popup' : selectedVisit.status === 'Denied' ? 'call-to-schedule' : selectedVisit.status === 'Expired' ? 'Expired' : selectedVisit.status === 'Completed' ? 'completed' : 'default-height'}`} ref={popupRef}>
                        {statusMessage?.mainTitle && (
                            <>
                                <div className="d-flex justify-content-between align-items-center mb-5">
                                    <span onClick={closeFullScreen}>
                                        <Image imgUrl={CloseIcon} altText={''} className={'popup-close-icon cursor-pointer'} />
                                    </span>
                                    <h5 className="sub-title mb-0">
                                        {statusMessage.mainTitle}
                                    </h5>
                                    <div></div>
                                </div>
                                <Image imgUrl={callToSchedule} altText={''} className={''} />
                            </>
                        )}

                        <h2 className={`title ${selectedVisit.status === 'Requested' ? '' : 'mt-3'}`}>
                            {statusMessage.title}
                            {/* Alert */}
                        </h2>
                        <div className="alert-container">
                            <p className="alert-description">
                                {/* Your requested colonoscopy is
                                under review. We will notify you
                                when once review is completed
                                Thank you for your patience */}
                                {statusMessage.message}
                            </p>
                        </div>
                        <Button btnClass={`btn-primary ${statusMessage?.buttonName?.toLowerCase() === 'call us' ? 'call-us-btn' : ''}`}
                            btnName={statusMessage?.buttonName ? statusMessage?.buttonName : 'Close'}
                            btnType={'button'}
                            onClick={closeFullScreen}
                            isDisabled={true}
                        />
                    </div>
                </div>
            )}
        </div>

    )
};

export default Visits;